import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  renderButtonText: {
    display: "block",
    textAlign: "left",
    fontSize: "17px",
  },
  deleteUser: {
    display: "block",
    textAlign: "left",
    fontSize: "14px",
    color: "red",
  },
  searchBarWrapper: {
    marginBottom: "20px",
    height: "50px",
  },
  statsCardWrapper: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    padding: "15px 15px 0",
  },
  statsCard: {
    width: "337px",
    height: "140px",
  },
  sectionLabel: {
    width: "100%",
    fontSize: "13px",
    fontWeight: 600,
    letterSpacing: "0.6px",
    color: "custom.text.lighter",
    margin: "22px 0 2px",
    padding: "0 15px",
  },
  entityTypeGridWrapper: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))",
    gap: "14px",
    padding: "0 15px 15px",
  },
});

export default styles;
